import PricingContainer from "../../../components/applications/eCommerce/pricing";

const Pricing = () => {
  return <PricingContainer />;
};

export default Pricing;
